import { useEffect, useState } from "react";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { IPanelEquipoModeloEliminar } from "./PanelEquipoModeloEliminar";
import { ITableModeloEquipoEdit } from "../../../../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo";
import EquipoModeloService from "../../../../../services/ListaVerificacion/EquipoModeloService";

export const UsePanelEquipoModeloEliminar = (
  props: IPanelEquipoModeloEliminar & { reloadCombo?: () => void }
) => {

  const [status, setStatus] = useState<codigosRespuesta>(0);
  const [mensaje, setMensaje] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [contentShow, setcontentShow] = useState(true);
  const [loadprogress, setloadprogress] = useState(false);

  const initial: ITableModeloEquipoEdit = {
    codigo: "",
    tipoEquipoId: "",
    equipoModeloId: ""
  };

  const [request, setRequest] = useState<ITableModeloEquipoEdit>(initial);

  const reset = () => {
    setMensaje("");
    setRequest(initial);
    setStatus(0);
    props.onDismiss();
  };

  useEffect(() => {
    if (props.isOpen) {
      setRequest(prev => ({
        ...prev,
        codigo: props.item.codigo,
        tipoEquipoId: props.item.tipoEquipoId,
        equipo: props.item.equipo,
        equipoModeloId: props.item.equipoModeloId
      }));
    }
  }, [props.isOpen]);

  const DeleteEquipoModelo = () => {
    setLoading(true);

    EquipoModeloService.DeleteEquipoModelosCommand(request.equipoModeloId)
      .then((res) => {
        if (res.status == 200) {
          setStatus(200);
          setloadprogress(true);
          setcontentShow(false);
          setMensaje(res.data.mensaje);

          setTimeout(() => {
            props.reloadCombo?.();
            props.reload?.();
            reset();
          }, 3000);
        } else {
          setStatus(500);
        }

        setLoading(false);
      })
      .catch((e) => {
        if (
          e.response?.data &&
          'type' in e.response.data &&
          'title' in e.response.data &&
          'status' in e.response.data &&
          'instance' in e.response.data &&
          'errors' in e.response.data
        ) {
          const errorResponse = e.response.data as IResponseApiFluent;
          const mensajeError = errorResponse.errors.join('\n');
          setMensaje(mensajeError);
        } else {
          setMensaje("Error Inesperado");
        }

        setStatus(500);
        setLoading(false);
      });
  };

  return {
    request,
    setRequest,
    DeleteEquipoModelo,
    loading,
    reset,
    mensaje,
    status,
    contentShow,
    loadprogress
  };
};